import script from "./Scanner.vue?vue&type=script&setup=true&lang=js"
export * from "./Scanner.vue?vue&type=script&setup=true&lang=js"

import "./Scanner.vue?vue&type=style&index=0&id=1b1a8ca2&scoped=true&lang=css"

import exportComponent from "/Users/asani/Documents/NODE/Graduation/fe-gradu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b1a8ca2"]])

export default __exports__